var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66665V13.3333H30V6.66665H33.345C34.2583 6.66665 35 7.40831 35 8.32165V35.0116C34.9996 35.4504 34.8251 35.8711 34.5148 36.1814C34.2045 36.4917 33.7838 36.6662 33.345 36.6666H6.655C6.21607 36.6666 5.79511 36.4923 5.48474 36.1819C5.17437 35.8715 5 35.4506 5 35.0116V8.32165C5 7.40831 5.74167 6.66665 6.655 6.66665H10ZM15 28.3333H11.6667V31.6666H15V28.3333ZM15 23.3333H11.6667V26.6666H15V23.3333ZM15 18.3333H11.6667V21.6666H15V18.3333ZM26.6667 3.33331V9.99998H13.3333V3.33331H26.6667Z",
    fill: "#F5A800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.23e73130593b74a848249c8441b13aec.svg";
export { ForwardRef as ReactComponent };